export const DATE_PLACES = [
    {
        date: "2025/12/05",
        dateName: "12月5日",
        city: "台北",
        hotel: "W hotel",
        time: "14:00"
    },
    {
         date: "2025/12/06",
        dateName: "12月6日",
        city: "台北",
        hotel: "W hotel",
        time: "14:00"
    },
    {
        date: "2025/12/07",
        dateName: "12月7日",
        city: "台中",
        hotel: "臺中勤美洲際酒店",
        time: "14:00"
    },
];

export const EVENT_MONTH = DATE_PLACES[0].date.split("/")[1];

export const TIME_SLOTS = ["14:00"];

export const PROJECT_INFO = {
    image: "binghatti.webp",
    secondImage: "binghatti-2.webp",
    title: "[Binghatti Skyblade杜拜城中心摩天新作】\n與 哈里發塔比肩而立的61層鉅獻，睽違一年、全球矚目登場！\n杜拜市中心最後一塊黃金地段，錯過再無。\n台灣投資人專屬說明會",
    name: "Binghatti Skyblade",
    description:
        " Binghatti 是總部位於杜拜的私營房地產開發商，成立於 2008 年，由 Dr. Hussain Binghatti 創立，目前已發展成為阿聯酋知名的大型開發集團，業務橫跨住宅、商辦、酒店及建設等領域。近年與多個國際頂級品牌合作推出「品牌公寓」：\nBurj Binghatti Jacob & Co Residences：預計成為全球最高的純住宅塔，坐落於 Business Bay。\nBugatti Residences by Binghatti：與超跑品牌 Bugatti 聯名，在 Business Bay 打造超高端「超豪宅」住宅塔\nMercedes-Benz Places | Binghatti：與賓士合作的品牌住宅專案，延伸其豪華車設計語彙到建築與室內。",
    benefitsTitle: "區域亮點",
    benefits: [
        `* 坐落杜拜市中心最後稀缺地段，緊鄰哈里發塔、杜拜購物中心、音樂噴泉與歌劇院，直通機場與主要幹道。`,
        `* 配備無邊際泳池、高端健身房、戶外電影院、共享辦公空間與兒童天地。`,
        `* 市中心租金穩定、供給有限，長線升值潛力可期。`,
    ],
    price: "起價600萬AED(約台幣5040萬）",
};
